import actions from '../actions';

export default {
	listenables: actions,

	_checkFacetRequirement(facet, requirement) {
		const selectedPropertyIds = [];
		const selectedFacetIds = [];

		Object.keys(this.state.userSelection).forEach((facetId) => {
			const propertyId = this.state.userSelection[facetId];
			selectedPropertyIds.push(parseInt(propertyId, 10));
			selectedFacetIds.push(parseInt(facetId, 10));
		});

		let isMatched = true;

		if (requirement.properties) {
			isMatched = !!requirement.properties
				.filter(requiredPropertyId => selectedPropertyIds.indexOf(requiredPropertyId) > -1)
				.length;
		}

		if (isMatched && requirement.facets) {
			isMatched = !!requirement.facets
				.filter(requiredFacetId => selectedFacetIds.indexOf(requiredFacetId) > -1)
				.length;
		}

		if (!isMatched) {
			this.state.filteredFacets.push(facet);
		}

		return isMatched;
	},

	_getResettingOtherFacetIdsForRequirements(facet, requirements) {
		const resettingOtherFacetIds = [];

		Object.keys(requirements).forEach((requirementFacetId) => {
			const requirementProperties = requirements[requirementFacetId].properties;
			if (!requirementProperties || !requirementProperties.length) {
				return;
			}

			requirementProperties.forEach((requiredPropertyId) => {
				for (const property of facet.properties) {
					if (property.id === requiredPropertyId) {
						resettingOtherFacetIds.push(requirementFacetId);
						return;
					}
				}
			});
		});

		return resettingOtherFacetIds;
	},

	_mapProperty(property, facet) {
		property.isSelected = facet.selectedProperty === property.id;
		property.isDeselectable = facet.selectedProperty === property.id && !facet.isPreselecting;

		// special sorting and label for numeric properties, defined per facet
		if (facet.propertyType === 'numeric') {
			property.sort = parseInt(property.label, 10);
			property.label = `${property.label} ${facet.unitLabel}`;
		}

		// save count
		property.preselectionItemCount = null;
		if (facet.isPreselecting) {
			if (property.count && (property.isSelected || !this.state.preselectionItemCounts[property.id])) {
				property.preselectionItemCount = this.state.preselectionItemCounts[property.id] = property.count;
			} else if (this.state.preselectionItemCounts[property.id]) {
				property.preselectionItemCount = this.state.preselectionItemCounts[property.id];
			}
		}

		property.isQuasiSelected = facet.quasiSelectedProperty === property.id;
		property.isDisabled = property.countUnselected === 0 && !facet.isPreselecting;
		return property;
	},

	_mapFacet(facet) {
		facet.selectedProperty = this.state.userSelection[facet.id];
		facet.isReduced = this.state.configuration.reducedFacets.indexOf(facet.id) > -1;
		facet.isPreselecting = !!this.state.configuration.preselection[facet.id];

		facet.selectableProperties = facet.properties.filter(property => property.countUnselected > 0);
		facet.quasiSelectedProperty = (
			facet.selectableProperties
			&& facet.selectableProperties.length === 1
			&& facet.selectableProperties[0].id
		);
		facet.properties = facet.properties.map(property => this._mapProperty(property, facet));

		if (facet.isPreselecting) {
			facet.preselectionItemCount = facet.properties.reduce((t, property) => t + property.preselectionItemCount, 0);
		}

		return facet;
	},

	_mapFacets(facets) {
		return facets
			.filter(facet => facet)
			.map(facet => this._mapFacet(facet));
	},

	_applyFacetRequirements(facets, requirements) {
		return facets
			.map((facet) => {
				facet.resettingOtherFacetIds = this._getResettingOtherFacetIdsForRequirements(facet, requirements);
				return facet;
			})
			.filter((facet) => {
				const requirement = requirements[facet.id];
				if (requirement) {
					return this._checkFacetRequirement(facet, requirement);
				}

				return true;
			});
	},

	onStateChange(state) {
		this.state.userSelection = state.userSelection;
	},

	onConfigurationChange(configuration) {
		this.state.configuration = configuration;
		// we assume this does not change so we do not trigger here
	},

	getState() {
		return {facets: this.state.facets};
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
};
